/* eslint-disable react/jsx-no-undef */
/* eslint-disable linebreak-style */
import { BrowserRouter } from 'react-router-dom';
import './shared/forms/TraducoesYup';
import { AppThemeProvider, AuthProvider, DrawerProvider, ModulosEmpresaProvider } from './shared/contexts';
import { Login, MenuLateral, ErrorBoundary } from './shared/components';
import { AppRoutes } from './routes';
import { GlobalHotkeys } from './GlobalHotkeys';
import { NavigationProvider } from './shared/contexts/NavigationContext';

export const App = () => {
  return (
    <AuthProvider>
      <AppThemeProvider>
        <Login>
          <ModulosEmpresaProvider>
          <DrawerProvider>
            <BrowserRouter>
            <NavigationProvider>
              <GlobalHotkeys />
              <MenuLateral>
                <ErrorBoundary>
                  <AppRoutes />
                </ErrorBoundary>
              </MenuLateral>
            </NavigationProvider>
            </BrowserRouter>
          </DrawerProvider>
          </ModulosEmpresaProvider>
        </Login>
      </AppThemeProvider>
    </AuthProvider>
  );
};